import React from 'react'
import PropTypes from 'prop-types'
import { useCallback } from 'sb-hooks'
import actions from 'redux/actions'
import { mixpanel, constants } from 'common/helpers'

import CloseIcon from 'components/ui/CloseIcon/CloseIcon'
import Image from 'components/_new/ui/Image/Image'
import DeliveryStatus from 'components/_new/DeliveryStatus/DeliveryStatus'
import UpchargePrice from 'components/UpchargePrice/UpchargePrice'

import s from './Product.scss'


const Product = (props) => {
  const {
    id, name, brand, image, upchargePrice,
    month, year, index, placement, disabled,
  } = props

  const handleClick = useCallback((event) => {

    mixpanel.track(constants.analyticsEvents.quickViewButton, {
      placement,
    })

    actions.models.modals.open(constants.modals.ProductDetails, { productId: id })

  }, [ id, placement ])

  const handleRemove = useCallback((event) => {
    event.preventDefault()
    event.stopPropagation()

    actions.models.queue.removeItem({
      id,
      index,
      page: placement,
      metadata: {
        placement: 'queue',
        name,
        brand,
      },
    })
  }, [ id, index, placement, name, brand ])

  return (
    <div key={id} className={s.product}>
      <div className={s.imageWrapper} onClick={handleClick}>
        {
          Boolean(upchargePrice) && (
            <UpchargePrice className={s.upchargePrice} price={upchargePrice} small />
          )
        }
        <Image className={s.image} src={image} h={100} x2 />
        {
          !disabled && (
            <CloseIcon className={s.removeButton} withRemoveLabel onClick={handleRemove} />
          )
        }
      </div>
      <div className={s.productInfoContainer}>
        <div>
          <div className={s.title}> {brand}</div>
          <div className={s.subTitle}>{name}</div>
        </div>
        <DeliveryStatus
          status="arrivesIn"
          deliveryDate={{ month, year }}
        />
      </div>
    </div>
  )
}

Product.propTypes = {
  id: PropTypes.any,
  name: PropTypes.string,
  brand: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  upchargePrice: PropTypes.number,
  month: PropTypes.number,
  year: PropTypes.number,
  placement: PropTypes.string,
  index: PropTypes.number,
}


export default Product
